module.exports = __webpack_public_path__ + "static/media/pill-icon-phone-support--white.bc617c07.svg";